export class LeadPatchModel {
    appointmentDate: Date;
    appointmentTime: string;
    userId: string;
    email: string;
    mobile: string;
    name: string;
    branchId: string;
    comment: string;
    shareLink: boolean;
    forexPurposes: string[];
    transactionMode: string;
    status: string;
    assignedTo: string;
    assignedBy: string;
    products: string[];
}
export class CallLaterPatchModel {
    status: string;
    appointmentDate: string;
    assignedTo: string;
    comment: string;
    appointmentTime: string;
    userId: string;
}
export class NotInterestedPatchModel {
    status: string;
    comment: string;
    informToPartner: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/lead/LeadPatchModel.ts